import { NgModule } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  exports: [MatFormFieldModule, MatInputModule, MatProgressBarModule]
})
export class MaterialImportsModule {}
